import { withdrawSol } from "@solana/spl-stake-pool";
import type { Connection } from "@solana/web3.js";
import { NATIVE_SOL } from "@stepfinance/common";
import type { Dispatch, SetStateAction } from "react";

import { confirmOptions } from "../../constants/transaction";
import type { CommonNotificationsStrings } from "../../contexts/language/languageTypes";
import type { ConnectedWallet } from "../../hooks/wallet/useConnectedWallet";
import { generateOneToOneNotificationDescription } from "../../utils/notifications";
import { sendTransaction } from "../../utils/transactions";
import { formatStringWithPlaceholders } from "../../utils/utils";
import { JITO_SOL_MINT, JITO_STAKE_POOL_ID } from "./stake";

export const jitoUnstake = async (
  wallet: ConnectedWallet,
  connection: Connection,
  amount: number,
  claimedAmount: number,
  onTransactionComplete: Dispatch<SetStateAction<boolean>>,
  notificationStrings: CommonNotificationsStrings,
) => {
  const amountToUnstake = amount;
  const withdrawInfo = await withdrawSol(
    connection,
    JITO_STAKE_POOL_ID,
    wallet.publicKey,
    wallet.publicKey,
    amountToUnstake,
  );

  return sendTransaction(
    connection,
    wallet,
    withdrawInfo.instructions,
    withdrawInfo.signers,
    true,
    confirmOptions,
    true,
    {
      approveMessage: notificationStrings.approveTransaction,
      inProgress: {
        message: formatStringWithPlaceholders(
          notificationStrings.youAreDoingAction.message,
          notificationStrings.youAreDoingAction.unstaked,
          "JitoSOL",
        ),
        description: notificationStrings.transactionInProgress,
      },
      success: {
        message: formatStringWithPlaceholders(
          notificationStrings.youDidAction.message,
          notificationStrings.youDidAction.unstaked,
          "JitoSOL",
        ),
        description: generateOneToOneNotificationDescription({
          tokenA: {
            action: notificationStrings.tokenBalanceChanges.unstaked,
            amount,
            mint: JITO_SOL_MINT,
            type: "decrease",
          },
          tokenB: {
            action: notificationStrings.tokenBalanceChanges.received,
            amount: claimedAmount,
            mint: NATIVE_SOL,
            type: "increase",
          },
        }),
      },
    },
    () => onTransactionComplete(true),
  );
};
